/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ best: NonNullable<unknown> }} Exercise_Goal_Already_MetInputs */

const en_us2_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your best is already ${i?.best} kg. Set a target above it.`)
};

const pt_br2_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua melhor marca já é ${i?.best} kg. Defina uma meta acima dela.`)
};

const es_419_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu mejor marca ya es ${i?.best} kg. Define una meta por encima.`)
};

const pt_pt2_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A tua melhor marca já é ${i?.best} kg. Define uma meta acima dela.`)
};

const fr_fr2_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton record est déjà de ${i?.best} kg. Fixe un objectif au-dessus.`)
};

const de_de2_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine Bestleistung liegt schon bei ${i?.best} kg. Setz ein Ziel darüber.`)
};

const it_it2_exercise_goal_already_met = /** @type {(inputs: Exercise_Goal_Already_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo massimo è già ${i?.best} kg. Imposta un obiettivo più alto.`)
};

/**
* | output |
* | --- |
* | "Your best is already {best} kg. Set a target above it." |
*
* @param {Exercise_Goal_Already_MetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_goal_already_met = /** @type {((inputs: Exercise_Goal_Already_MetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Goal_Already_MetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_goal_already_met(inputs)
	if (locale === "es-419") return es_419_exercise_goal_already_met(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_goal_already_met(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_goal_already_met(inputs)
	if (locale === "de-DE") return de_de2_exercise_goal_already_met(inputs)
	if (locale === "it-IT") return it_it2_exercise_goal_already_met(inputs)
	return en_us2_exercise_goal_already_met(inputs)
});
export { exercise_goal_already_met as "exercise_goal.already_met" }